import _ from 'lodash';
import { Component, Input, Output, EventEmitter, NgZone, ViewChild, ElementRef, Renderer} from '@angular/core';
import { OceanLineModel, AlertService, Port, PortService, CountryService, CityService, Country, City, SaveLocationModel, GmapLogService} from 'app/services/index'
declare var $:any;
import { MapsAPILoader } from '@agm/core';
declare var google:any;
import { FormControl } from '@angular/forms';
import { Subscription } from 'rxjs/Subscription';

@Component({
  selector: 'port-detail',
  templateUrl: 'port-detail.html',
  styles: [`
  agm-map {
    height: 300px;
  }`]
  
})
export class PortDetailComponent {

    _portId:number;
    port:Port = new Port();
    cntryList:Array<Country> = new Array<Country>();
    cityList:Array<City> = new Array<City>();
    portList:Array<Port> = new Array<Port>();
    
    @Output() onRefresh: EventEmitter<any> = new EventEmitter();
    @Output() onClose: EventEmitter<any> = new EventEmitter();

    isOpenModal:boolean = false;
    
    defaultLatitude: number = 35.907756;
	defaultLongitude: number = 127.766922;
    searchControl: FormControl;
    zoom: number = 12;

    @ViewChild("search")
    searchElementRef: ElementRef;

    autocomplete:any;

    test:string;

    geocoder:any;

    countryListEeSub:Subscription;
    portListEeSub:Subscription;

    constructor(   
        private alertService:AlertService,
        private portService:PortService,
        private countryService:CountryService,
        private cityService:CityService,
        private mapsAPILoader: MapsAPILoader,
        private ngZone: NgZone,
        private gmapLogService: GmapLogService
    ) {
    }

    @Input() set portId(portId){
        this.port = new Port();
        this._portId = portId;
        if(portId != null) this.getPort(portId);
    }

    ngOnInit() {
        this.countryListEeSub = this.countryService.countryListEe.subscribe(
            data =>{
                this.cntryList = data;   
            }
        );
        if(!this.countryService.ingFlag){
            this.countryService.getCountries();
        }
                
        this.portListEeSub = this.portService.portListEe.subscribe(
            data =>{
                this.portList = data;
            }
        )
        if(!this.portService.ingFlag){
            this.portService.getPortList();
        }

        // this.port.latitude = 35.8026689;
        // this.port.longitude = 126.520036;

        //create search FormControl
        this.searchControl = new FormControl();

        this.mapsAPILoader.load().then(() => {
            var input = document.getElementById('map-search'); 

            this.geocoder = new google.maps.Geocoder();

            this.autocomplete = new google.maps.places.Autocomplete(input, {fields: ["name", "address_components", "geometry.location"]});
            this.gmapLogService.log('consult-detail', 'PLACE');

            let hasDownBeenPressed = false;
            
            input.addEventListener('keydown', (e) => {
              if (e.keyCode === 40) {
                hasDownBeenPressed = true;
              }
            });
      
            google.maps.event.addDomListener(input, 'keydown', (e) => {
              
              e.cancelBubble = true;
            
              if (e.keyCode === 0 || e.keyCode === 13 || e.keyCode === 9) {
                if (!hasDownBeenPressed && !e.hasRanOnce) {
                  google.maps.event.trigger(e.target, 'keydown', {
                      keyCode: 40,
                      hasRanOnce: true,
                  });
                }
              }
            });
      
            input.addEventListener('focus', () => {
              hasDownBeenPressed = false;
              $(input).value = '';
            });
            
            this.autocomplete.addListener("place_changed", () => {
              this.ngZone.run(() => {
                let place = this.autocomplete.getPlace();
      
                if (place.geometry === undefined || place.geometry === null) {
                  return;
                }

                this.port.latitude = place.geometry.location.lat();
                this.port.longitude = place.geometry.location.lng();
                this.zoom = 12;

                this.getTimeZone(place.geometry.location.lat(), place.geometry.location.lng());

              });
            });
          });

    }

    getPort(portId:number){
        this.portService.getPort(portId).subscribe(
            res => {
                if(res.result) {
                    this.port = res.data;
                }
            }
        );
    }

    countrySelected(event, isInit?:boolean) {
        if(event != null) {
            this.cityService.getCities(event.cntryCd).subscribe(
                data =>{
                    this.cityList = data;
                }
            )
            this.port.cntryCd = event.cntryCd;
            this.port.cntryNm = event.cntryNm;
        } else {
            this.cityList = null;
            this.port.cntryCd = null;
            this.port.cntryNm = null;
        }
    }

    selecedCity(event:City){
        let that = this;
        if(event != null) {
            let tempList = _.find(this.portList, (port:Port) => {
                if(port.unCd != null && event.unCd != null && port.unCd == event.unCd) return true;
                else if(port.portCd != null && event.cityCd != null && port.portCd.indexOf(event.cityCd) > -1) return true;
                else false;
            });

            if(tempList == null || tempList.length < 1){
                $.sweetModal.confirm('도시에서 선택한 값이 항만에 존재하지 않습니다. 항구 정보에 새로 입력하시겠습니까?', function() {
                    that.port.portCd = event.cityCd;
                    that.port.portNm = event.name;
                    that.port.type = 'port';
                    that.port.unCd = event.unCd;
                    that.port.cntryCd = event.cntryCd;
                    that.test = event.name;

                    that.geocoder.geocode( { 'address' : event.name }, function( results, status ) {
                        if( status == google.maps.GeocoderStatus.OK ) {
                          that.port.latitude = results[0].geometry.location.lat();
                          that.port.longitude = results[0].geometry.location.lng();
                          that.getTimeZone(that.port.latitude, that.port.longitude);
                        } else {
                            console.log('address error');
                        }
                      });

                }, function() {
                });     
            }else{
                $.sweetModal({
                    content: "입력하신 도시는 항만에 존재합니다. 리스트에서 항만을 클릭 한 후 수정해주세요.",
                    icon: $.sweetModal.ICON_WARNING,
                    onClose: function () {
                        that.isOpenModal = false;
                    }
                });
            }
        } else {
            this.port.portCd = null;
            this.port.portNm = null;
            this.port.type = null;
            this.port.unCd = null;
            this.port.cntryCd = null;
        }
    }

    checkExistData(event:boolean){
        let that = this;
        if(!event && !this.isOpenModal){
            this.isOpenModal = true;
            $.sweetModal({
                content: "국가를 선택해주세요.",
                icon: $.sweetModal.ICON_WARNING,
                onClose: function () {
                    that.isOpenModal = false;
                }
            });
        }
    }

    save(){
        let that = this;
        $.sweetModal.confirm('저장하시겠습니까?', function() {
            if(that.port.portNm == null || that.port.portCd == null){
                that.alertService.error("항만 입력은 필수 입니다. 항만을 등록해주세요.");
                return ;
            }

            let location:SaveLocationModel = new SaveLocationModel();
            location.locationType = 1;
            location.locationTypeNm = 'PORT';
            location.cntryCd = that.port.cntryCd;
            location.locationCd = that.port.portCd;
            location.name = that.port.portNm;
            location.unCd = that.port.unCd;
            location.latitude = that.port.latitude;
            location.longitude = that.port.longitude;
            location.timeZone = that.port.timeZone;
            location.locationId = that.port.locationId;
            location.nameKr = that.port.portNmKr;

            if(that.port.locationId == null || that.port.locationId == undefined) {
                that.portService.postPort([location]).subscribe(
                    res =>{
                        if(res.result){
                            that.alertService.success("저장 되었습니다.");
                            that.onRefresh.emit();
                        }
                    }
                );                
            }else{
                that.portService.patchPort([location]).subscribe(
                    res =>{
                        if(res.result){
                            that.alertService.success("저장 되었습니다.");
                            that.onRefresh.emit();
                        }
                    }
                );    
            }

        }, function() {
        });
    }

    ngOnDestroy(){
        if(this.countryListEeSub) this.countryListEeSub.unsubscribe();
        if(this.portListEeSub) this.portListEeSub.unsubscribe();
    }

    mapClick(event){
        this.port.latitude = event.coords.lat;
        this.port.longitude = event.coords.lng;
        this.getTimeZone(this.port.latitude, this.port.longitude);
    }

    getTimeZone(lat, lng){
        this.portService.getTimeZone(lat, lng).subscribe( 
            (res:any) => {
                if(res.status == 'OK'){
                    this.port.timeZone = res.rawOffset/3600;
                }
            }
        );
    }

    close(){  
        this.port = new Port();
        this.onClose.emit();
    }
}






// WEBPACK FOOTER //
// ./src/app/containers/port-map/port-detail.ts